import { render, staticRenderFns } from "./management-question-view.vue?vue&type=template&id=b3da6c6a&scoped=true&"
import script from "./management-question-view.vue?vue&type=script&lang=js&"
export * from "./management-question-view.vue?vue&type=script&lang=js&"
import style0 from "./management-question-view.vue?vue&type=style&index=0&id=b3da6c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3da6c6a",
  null
  
)

export default component.exports